// import { useRef } from "react";
// import emailjs from "@emailjs/browser";
import GITHUB_ICON from "../../icons/github.svg";
import LINKEDIN_ICON from "../../icons/linkedin.svg";
import YT_ICON from "../../icons/icons8-youtube.svg";
import GMAIL_ICON from "../../icons/icons8-gmail.svg";

const Contact = () => {
  return (
    <div>
      <h2 className="text-3xl mt-10">You can find me here</h2>
      <div className="border-t-2 w-[22%] mb-10 border-solid border-neutral-400  h-2"></div>
      <p className=" text-xl px-5">
        Whether you have innovative concepts to explore or simply want to chat,
        let's connect and learn together. Feel free to reach out for discussions
        or potential collaborations!
      </p>
      <div className="my-10 px-5 flex justify-start flex-wrap gap-10">
        <div className="LinkedIn transition ease-in-out delay-75 hover:-translate-y-1 hover:scale-95 duration-75">
          <a
            className="flex items-center"
            href="https://www.linkedin.com/in/hrithik-k-9b0b10230/"
          >
            <img
              // width="48"
              // height="48"
              className="w-10"
              src={LINKEDIN_ICON}
              alt="linkedin"
            />
            LinkedIn
          </a>
        </div>
        <div className="GitHub transition ease-in-out delay-75 hover:-translate-y-1 hover:scale-95 duration-75">
          <a className="flex items-center" href="https://github.com/Hrithik06">
            <img
              // width="48"
              // height="48"
              className="w-10"
              src={GITHUB_ICON}
              alt="github--v1"
            />
            GitHub
          </a>
        </div>
        <div className="E-Mail transition ease-in-out delay-75 hover:-translate-y-1 hover:scale-95 duration-75">
          <a className="flex items-center" href="mailto:writhik.dev@gmail.com">
            <img
              // width="48"
              // height="48"
              className="w-10"
              src={GMAIL_ICON}
              alt="mail--v1"
            />
            Email
          </a>
        </div>

        <div className="YouTube transition ease-in-out delay-75 hover:-translate-y-1 hover:scale-95 duration-75">
          <a
            className="flex items-center"
            href="      https://www.youtube.com/@Hrithik-ws1up
"
          >
            <img
              // width="48"
              // height="48"
              className="w-10"
              src={YT_ICON}
              alt="youtube-play"
            />
            YouTube
          </a>
        </div>
      </div>
    </div>
  );
};
export default Contact;
